import { matchPath } from 'react-router'

const SHARE_TOKEN_PATHS = [
  '/exam/:id',
  '/exam/:id/spectrogram',
  '/consultation/:id',
]

export const getShareToken = (search) => {
  const currentSearch = search ?? (
    typeof window !== 'undefined' ? window.location.search : ''
  )
  return new URLSearchParams(currentSearch).get('share')
}

export const getShareTokenReturnPath = (path) => {
  if (typeof path !== 'string') return null

  const queryIndex = path.indexOf('?')
  if (queryIndex === -1) return null

  const pathname = path.slice(0, queryIndex)
  const search = path.slice(queryIndex + 1)
  const isShareTokenPage = SHARE_TOKEN_PATHS.some(route =>
    matchPath({ path: route, end: true }, pathname)
  )

  return isShareTokenPage && new URLSearchParams(search).has('share')
    ? path
    : null
}
